import { connect } from 'react-redux';
import Header from './Header';

const getTitle = ({ reviews_as_seller: reviewsAsSeller, studio_id: studioId, gig_id: gigId }, isBuyerProfile) => {
    let title;

    if (isBuyerProfile) {
        title = 'reviews.header.buyer_profile';
    } else if (gigId || studioId) {
        title = 'reviews.header.gig';
    } else if (reviewsAsSeller) {
        title = 'reviews.header.as_seller';
    } else {
        title = 'reviews.header.as_buyer';
    }
    return title;
};

const mapStateToProps = (state, props) => {
    const showBreakdown = state.breakdown && state.displayBreakdown;

    return {
        title: getTitle(state, props.isBuyerProfile),
        ratingFive: state.average_valuation,
        starSummary: state.star_summary,
        totalCount: state.total_count,
        showBreakdown,
        ...props,
    };
};

export default connect(mapStateToProps)(Header);
